<template>
  <svg
    :data-testid="props.dataTestid"
    :key="props.keyCode"
    class="ts-icon"
    :class="spinnerIcons.includes(props.name) ? 'animate-spin' : ''"
  >
    <use :xlink:href="'/static/icons/sprite.svg#' + props.name"></use>
  </svg>
</template>

<script setup lang="ts">
defineOptions({
  inheritAttrs: true,
});

type Props = {
  name?: string;
  color?: string;
  size?: string;
  keyCode?: string;
  dataTestid?: string;
};

const spinnerIcons = ["eos-icons:loading"];

const props = withDefaults(defineProps<Props>(), {
  name: "clarity:dot-circle-line",
  size: "2rem",
  keyCode: "ts-icon",
  dataTestid: "atom-icon",
});
</script>
